import React, { useEffect, useState } from 'react';
import { MainLayout } from '../../companyProfiles/layouts/mainLayout/MainLayout';

import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';
import { Loader } from 'braid-design-system';
import { useAuth } from '../../shared/providers/authProvider';
import { WriteAReviewContainer } from '../pages/WriteAReviewContainer';

type Props = React.PropsWithChildren;

export function WriteAReviewLayout(_props: Props) {
  const { authenticationStatus, ssoLogin } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Set isLoading to false only when authenticated
    setIsLoading(authenticationStatus !== AUTHENTICATION_TYPES.AUTHENTICATED);

    // Trigger SSO login if unauthenticated
    if (
      authenticationStatus === AUTHENTICATION_TYPES.UNAUTHENTICATED &&
      ssoLogin
    ) {
      void ssoLogin();
    }
  }, [authenticationStatus, ssoLogin]);

  return (
    <MainLayout pageWidth="medium" showHeaderDivider>
      {isLoading ? <Loader /> : <WriteAReviewContainer />}
    </MainLayout>
  );
}
